// extracted by mini-css-extract-plugin
export default {"loader":"Spinner_loader__3atyy","load1":"Spinner_load1__Nox-g"};